import { useSelector, useDispatch } from 'react-redux';
import FJModal from '../FJModal';
import FJDoNotShowAgainModal from './FJDoNotShowAgainModal';
import FJActionModal from '../../../redux/action/FJActionModal';
import { useCallback } from 'react';

function FJDoNotShowAgainModalContainer() {
    const dispatch = useDispatch();
    const doNotShowAgainData = useSelector(state => state.modals.doNotShowAgainData);
    const { display, id, callback, type } = doNotShowAgainData;

    const onClose = useCallback(
        flag => {
            callback?.(flag);
            dispatch(FJActionModal.hideDoNotShowAgainModalAction());
        },
        [callback, dispatch],
    );

    return (
        <FJModal visible={display} zIndex={9999}>
            <FJDoNotShowAgainModal onClose={onClose} id={id} type={type} />
        </FJModal>
    );
}

export default FJDoNotShowAgainModalContainer;
